import { getAdminBasePath, getAdminBaseRoute } from "../AdminRoutes";
export const getProfilePhotoUploadBasePath = () => `${getAdminBasePath()}/profilePhotoUpload`;
export const getProfilePhotoUploadBaseRoute = () => `${getAdminBaseRoute()}/profilePhotoUpload`;
